import { Button, Grid, Menu, TextField, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import clsx from 'clsx';
import { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { isMobilePhoneNumber, normalizePhone, removeWhiteSpaces } from '@/utils/formUtils';

import CountrySearch from './CountrySeach/CountrySearch';
import { useStyles } from './TelephoneDropDownClass';

const TelephoneDropDown = ({
    setData,
    mainDataHeading,
    data,
    compulsory,
    errorText,
    validateForm = () => {},
    error,
    isScroll,
    setError,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const classes = useStyles();
    const matchesMd = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileCodeWidth, setMobileCodeWidth] = useState('0');
    const [mobileCode, setMobileCode] = useState('+49');
    const [anchorE1, setAnchorE1] = useState(null);
    const [mobileNumber, setMobileNumber] = useState('');

    useEffect(() => {
        if (!data) return;

        const normalized = normalizePhone(data);
        if (!normalized) return;

        const { code, number } = normalized;
        setMobileCode(code);
        setMobileNumber(number);
    }, [data]);

    const messageRef = useRef();

    const handleDivClicked = () => {
        if (messageRef.current) {
            messageRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    };

    const handleClick = (event) => {
        const w =
            document.getElementById('mobileNumber').clientWidth +
            document.getElementById('mobileCodeButton').clientWidth;
        setMobileCodeWidth(w.toString());
        setAnchorE1(event.currentTarget);
    };

    const handleClose = (mobileCodee = '') => {
        setAnchorE1(null);
        if (mobileCodee !== '') {
            if (mobileNumber) setData(mobileCodee.concat(` ${mobileNumber}`));
            setMobileCode(mobileCodee);
        }
    };

    const validateForm1 = (input) => {
        const number = removeWhiteSpaces(mobileCode + (input ?? mobileNumber));
        // Allow +49 placeholder (treat as empty/optional)
        if (number === '+49' || number === '') {
            setError(false);
            return;
        }
        if (!isMobilePhoneNumber(number)) {
            setError(true);
        } else {
            setError(false);
        }
    };

    const handleField = (event) => {
        const inputField = event.target.value;
        setData(mobileCode.concat(` ${inputField}`));
        setMobileNumber(inputField);
        validateForm1(inputField);
    };

    return (
        <>
            <div
                ref={isScroll ? messageRef : null}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 10,
                }}
                className={error && classes.redBorder}
            >
                <Grid item lg={2} md={3} sm={3} xs={3}>
                    <Button
                        id="mobileCodeButton"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={(e) => {
                            handleClick(e);
                            if (isScroll) {
                                handleDivClicked();
                            }
                        }}
                        disableRipple
                        className={classes.formControl}
                        classes={{ label: classes.menuLabel }}
                        style={{
                            borderBottom: anchorE1 ? 'none' : null,
                            borderBottomLeftRadius: anchorE1 ? 0 : theme.radius.default,
                            borderTopLeftRadius: theme.radius.default,
                            border: !anchorE1 && `1px solid ${theme.palette.common.brown} `,
                            borderRight: 'none !important',
                            backgroundColor: anchorE1 ? theme.palette.common.lightBrownDropdown : 'white',
                            borderLeft: anchorE1
                                ? `3px solid ${theme.palette.common.yellow}`
                                : `1px solid ${theme.palette.common.brown}`,
                            borderTop: anchorE1
                                ? `3px solid ${theme.palette.common.yellow}`
                                : `1px solid ${theme.palette.common.brown}`,
                        }}
                    >
                        <div>
                            <Typography className={classes.ButtonTextClassMain}>{mobileCode}</Typography>
                        </div>
                        <KeyboardArrowDownIcon
                            className={classes.downArrow}
                            style={{ transform: anchorE1 ? 'rotate(180deg)' : 'none' }}
                        />
                    </Button>

                    <Menu
                        id="simple-menu"
                        anchorEl={anchorE1}
                        keepMounted
                        elevation={0}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                        }}
                        open={Boolean(anchorE1)}
                        onClose={() => {
                            handleClose();
                        }}
                        PaperProps={{
                            style: {
                                width: matchesMd ? parseFloat(mobileCodeWidth) + 7 : parseFloat(mobileCodeWidth) + 8,
                                maxHeight: 610,
                                minHeight: 119,
                                borderBottom: `3px solid ${theme.palette.common.yellow}`,
                                borderLeft: `3px solid ${theme.palette.common.yellow}`,
                                borderRight: `3px solid ${theme.palette.common.yellow}`,
                                backgroundColor: theme.palette.common.lightBrownDropdown,

                                marginTop: '-2px',
                            },
                        }}
                    >
                        <CountrySearch
                            data={mobileCode}
                            setData={setMobileCode}
                            mainDataPlaceHolder={t('typeYourCountry')}
                            openProp={anchorE1}
                            closeDropDown={setAnchorE1}
                            widthLocal={mobileCodeWidth}
                        />
                    </Menu>
                </Grid>
                {/* Text field */}
                <Grid item md={10} sm={9} xs={9}>
                    <TextField
                        id="mobileNumber"
                        autoComplete="off"
                        label={mainDataHeading}
                        variant="filled"
                        color="primary"
                        type="number"
                        value={mobileNumber}
                        onBlur={handleField}
                        onChange={handleField}
                        fullWidth
                        classes={classes.textFields}
                        InputLabelProps={{
                            classes: {
                                root: classes.inputLabel,
                                focused: 'focused',
                                shrink: 'shrink',
                            },
                        }}
                        InputProps={{
                            classes: {
                                root: anchorE1
                                    ? clsx(classes.coloredRoot, classes.filledInputRoot)
                                    : classes.filledInputRoot,
                                focused: classes.fieldFocused,
                                shrink: 'shrink',
                            },
                        }}
                    />
                </Grid>
            </div>
            {error && <Typography className={classes.errorText}>{errorText}</Typography>}
        </>
    );
};

export default memo(TelephoneDropDown);
